import { Box, Container } from '@mui/material'
import { ReactNode } from 'react'
import { ACTION_GAP_MAX, SPACE } from '../styles/layout'

/**
 * Holds the action buttons at the end of a screen.
 *
 * Phones (xs): the spacer above the buttons grows without limit, so the
 * buttons sit at the bottom of the screen within thumb reach, as before.
 *
 * Tablet and desktop (sm, 640px, and up): the spacer still grows to push the buttons down,
 * but only up to ACTION_GAP_MAX. On a long screen nothing changes (the gap is
 * already small). On a short screen the buttons stop at the cap instead of
 * floating at the foot of a tall window.
 */
const ZBottomContainer = ({ children }: { children: ReactNode }) => {
  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        flex: 1,
        paddingBottom: SPACE['3xl'],
      }}
    >
      <Box
        aria-hidden
        sx={{ flex: '1 1 0', maxHeight: { xs: 'none', sm: ACTION_GAP_MAX } }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: SPACE.sm,
          alignItems: 'center',
          width: '100%',
        }}
      >
        {children}
      </Box>
    </Container>
  )
}

export default ZBottomContainer
